
      setTimeout(() => {
        const script = document.createElement('script');
        script.type = 'module';
        script.crossOrigin = true;
        script.src = '/src/app/main.tsx';
        document.body.appendChild(script);
      }, 3050);
    